import HistoryIcon from '@material-ui/icons/History';
import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { IMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import IFatura from '@model/Fatura';
import { EnumFaturaStatus } from '@model/FaturaStatus';
import { useFaturaService } from '@services/FaturaService';
import React from 'react';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CancelIcon from '@material-ui/icons/Cancel';
import { useAuthProvider } from '@components/AuthProvider';
import { Permission } from '@app/Permission';
import { Divider } from '@material-ui/core';
import LockOpenIcon from '@material-ui/icons/LockOpen';

export type FaturaMenuProps = {
    menu: IMenu
    fatura: IFatura
    cancelarModal: IModalWindow
    reabrirModal: IModalWindow
    desfazerCancelamentoModal: IModalWindow
    atividadeModal: IModalWindow
}

export function FaturaMenu ({ fatura, menu, cancelarModal, reabrirModal, desfazerCancelamentoModal, atividadeModal }: FaturaMenuProps) {
    const faturaService = useFaturaService();
    const message = useMessage();
    const authProvider = useAuthProvider();
    
    const handleBaixarBoleto = React.useCallback(() => {
        faturaService.baixarBoleto(fatura.faturaId)
            .catch(message.showBlobException);
    }, [fatura.faturaId, faturaService, message.showBlobException]);

    return (
        <RowMenu menu={menu}>
            <RowMenuItem 
                key={0} 
                onClick={menu.handleItemClick(handleBaixarBoleto)}
                text="Baixar Boleto"
                icon={<CloudDownloadIcon />}
            />
            {
                authProvider.hasPermission(Permission.FaturaCancelar) && fatura.faturaStatusId === EnumFaturaStatus.Aberta && (
                    <RowMenuItem 
                        key={1} 
                        onClick={menu.handleItemClick(cancelarModal.open)}
                        text="Cancelar Fatura"
                        icon={<CancelIcon />}
                    />
                )
            }

            {
                authProvider.hasPermission(Permission.FaturaDesfazerCancelamento) && fatura.faturaStatusId === EnumFaturaStatus.Cancelada && (
                    <RowMenuItem 
                        key={1} 
                        onClick={menu.handleItemClick(desfazerCancelamentoModal.open)}
                        text="Desfazer Cancelamento da Fatura"
                        icon={<CancelIcon />}
                    />
                )
            }

            {
                authProvider.hasPermission(Permission.FaturaReabrir) && fatura.faturaStatusId === EnumFaturaStatus.Paga && (
                    <React.Fragment>
                        <Divider />
                        <RowMenuItem 
                            key={"dev-1"}
                            onClick={menu.handleItemClick(reabrirModal.open)}
                            text="Reabrir Fatura"
                            icon={<LockOpenIcon />}
                        />
                    </React.Fragment>
                )
            }

            <Divider />

            <RowMenuItem 
                key={2} 
                onClick={menu.handleItemClick(atividadeModal.open)}
                text="Atividades"
                icon={<HistoryIcon />}
            />
        </RowMenu>
    )
}